import * as XLSX from "xlsx-js-style";

const COLLECTION_CONFIG = {
  fc_variant: {
    sheetName: "FC_Variant_Export",
    headers: [
      "FC PRODUCT",
      "BEG. INV",
      "SALES CNT",
      "ENDING",
      "P. COUNT",
      "COSTOFGOODS",
      "IDEAL",
      "VARIANT",
    ],
    colWidths: [
      { wch: 28 },
      { wch: 12 },
      { wch: 10 },
      { wch: 12 },
      { wch: 10 },
      { wch: 12 },
      { wch: 10 },
      { wch: 10 },
    ],
    mapRow: (r) => [
      r.fcProduct,
      Number(r.beginningInventory) || 0,
      Number(r.saleCount) || 0,
      Number(r.ending) || 0,
      Number(r.pCount) || 0,
      Number(r.costOfGoods) || 0,
      Number(r.ideal) || 0,
      Number(r.variant) || 0,
    ],
    numFmtCols: [1, 2, 3, 4, 5, 6, 7],
    // { col index -> rgb color } applied to header font AND all data cells in that col
    colColors: {
      6: "FF0000", // IDEAL -> red
      7: "0000FF", // VARIANT -> blue
    },
  },
  inventory_movement: {
    sheetName: "Inventory_Movement_Export",
    headers: [
      "SKU",
      "FC PRODUCT",
      "DELIVERY",
      "DIRECT PURCHASE",
      "STOCK TRANSFER IN",
      "STOCK TRANSFER OUT",
      "WASTE",
      "SALE COUNT",
    ],
    colWidths: [
      { wch: 20 },
      { wch: 28 },
      { wch: 14 },
      { wch: 18 },
      { wch: 20 },
      { wch: 20 },
      { wch: 12 },
      { wch: 14 },
    ],
    mapRow: (r) => [
      r.sku,
      r.fc_product,
      Number(r.Delivery) || 0,
      Number(r.DirectPurchase) || 0,
      Number(r.StockTransferIn) || 0,
      Number(r.StockTransferOut) || 0,
      Number(r.Waste) || 0,
      Number(r.SaleCount) || 0,
    ],
    numFmtCols: [2, 3, 4, 5, 6, 7],
    colColors: {},
  },
};

export function exportToExcel(filename, rows, collection) {
  const config = COLLECTION_CONFIG[collection] ?? COLLECTION_CONFIG.fc_variant;
  const { sheetName, headers, colWidths, mapRow, numFmtCols, colColors } =
    config;

  const data = [headers, ...rows.map(mapRow)];
  const ws = XLSX.utils.aoa_to_sheet(data);

  // Freeze first row + autofilter
  ws["!freeze"] = { xSplit: 0, ySplit: 1 };
  ws["!autofilter"] = {
    ref: XLSX.utils.encode_range({
      s: { r: 0, c: 0 },
      e: { r: data.length - 1, c: headers.length - 1 },
    }),
  };

  ws["!cols"] = colWidths;

  // Number format + right-align for numeric cols
  for (let r = 1; r < data.length; r++) {
    for (const c of numFmtCols) {
      const addr = XLSX.utils.encode_cell({ r, c });
      if (ws[addr]) {
        ws[addr].z = "#,##0.00";
        ws[addr].s = {
          ...(ws[addr].s || {}),
          alignment: { horizontal: "right" },
        };
      }
    }
  }

  // Header row styling
  for (let c = 0; c < headers.length; c++) {
    const addr = XLSX.utils.encode_cell({ r: 0, c });
    if (!ws[addr]) continue;

    ws[addr].s = {
      font: {
        bold: true,
        color: { rgb: colColors[c] ?? "FFFFFF" },
      },
      fill: { fgColor: { rgb: "1F1F1F" } },
      alignment: { horizontal: "center", vertical: "center" },
    };
  }

  // Per-column data cell colors
  for (const [colStr, rgb] of Object.entries(colColors)) {
    const c = Number(colStr);
    for (let r = 1; r < data.length; r++) {
      const addr = XLSX.utils.encode_cell({ r, c });
      if (ws[addr]) {
        ws[addr].s = {
          ...(ws[addr].s || {}),
          font: { color: { rgb }, bold: false },
          alignment: { horizontal: "right" },
        };
      }
    }
  }

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, sheetName);
  XLSX.writeFile(
    wb,
    filename.endsWith(".xlsx") ? filename : `${filename}.xlsx`,
  );
}
